import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import TextGroup from '../../molecules/TextGroup';

import styles from './ForgotPasswordSuccessBlock.module.scss';
import usePresenter from './ForgotPasswordSuccessBlock.presenter';
import getProps from './ForgotPasswordSuccessBlock.props';
import { ForgotPasswordSuccessBlockCombinedProps } from './types';


const ForgotPasswordSuccessBlock: React.FC<ForgotPasswordSuccessBlockCombinedProps> = (props) => {
  const {
    className,
    classes,
    textGroup,
    textGroup1,
    button,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.forgotPasswordSuccessBlock;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.topContent, classes?.topContent)}>
        <TextGroup
          className={cx(styles.textGroup, classes?.textGroup)}
          {...internalProps.textGroup}
          {...textGroup}/>
      </div>
      <div className={cx(styles.middleContent, classes?.middleContent)}>
        <TextGroup
          className={cx(styles.textGroup1, classes?.textGroup1)}
          {...internalProps.textGroup1}
          {...textGroup1}/>
      </div>
      <div className={cx(styles.bottomContent, classes?.bottomContent)}>
        <Button
          className={cx(styles.button, classes?.button)}
          {...internalProps.button}
          {...button}/>
      </div>
    </div>
  );
};

export default ForgotPasswordSuccessBlock;

